import * as React from 'react';
import {Item} from '../item.class';
import {User} from '../../users/user.class';
import Button from '../../ui/Buttons/Button';
import {useState} from 'react';
import {tableDataStylesAlignMiddle, tableDataStylesAlignTop, tableHeaderStylesNoBorder} from '../../ui/Tables/TableClasses';
type IDPTabsProps = {
    item: Item;
    isInternalUser: boolean;
    user: User;
};
const NBSPReplace = /&nbsp;/g;
export const IDPTabs = ({item, isInternalUser, user}: IDPTabsProps) => {
    const [openTab, setOpenTab] = useState('catalog');

    return (
        <div className="print:tw-hidden">
            <ul
                className="tw-flex tw-flex-wrap tw-pl-0 tw-mb-6 tw-list-none"
                id="itemDetailTabs"
                role="tablist"
            >
                {isInternalUser && (
                    <li
                        className={`tw-border-b tw-list-none${
                            openTab === 'catalog' ? ' tw-border-t tw-border-x tw-border-b-white [&_button]:!tw-text-gray-500' : ''
                        }`}
                    >
                        <Button
                            aria-controls="info"
                            aria-selected="true"
                            data-toggle="tab"
                            id="info-tab"
                            onClick={() => {
                                setOpenTab('catalog');
                            }}
                            size="sm"
                            variant="tab"
                        >
                            Catalog
                        </Button>
                    </li>
                )}
                {item.publicXref?.length > 0 && (
                    <li
                        className={`tw-border-b tw-list-none${
                            openTab === 'xRef' ? ' tw-border-t tw-border-x tw-border-b-white [&_button]:!tw-text-gray-500' : ''
                        }`}
                    >
                        <Button
                            aria-controls="xrefs"
                            aria-selected="false"
                            data-toggle="tab"
                            id="xrefs-tab"
                            onClick={() => {
                                setOpenTab('xRef');
                            }}
                            size="sm"
                            variant="tab"
                        >
                            Cross References
                        </Button>
                    </li>
                )}
                <li
                    className={`tw-border-b tw-list-none${
                        openTab === 'legal' ? ' tw-border-t tw-border-x tw-border-b-white [&_button]:!tw-text-gray-500' : ''
                    }`}
                >
                    <Button
                        aria-controls="legal"
                        aria-selected="false"
                        data-toggle="tab"
                        id="legal-tab"
                        onClick={() => {
                            setOpenTab('legal');
                        }}
                        size="sm"
                        variant="tab"
                    >
                        Legal
                    </Button>
                </li>
                <div className="tw-flex-grow">
                    <li className="tw-border-b tw-h-[42px]"></li>
                </div>
            </ul>
            <div className="tw-mt-6">
                {openTab === 'catalog' && isInternalUser && (
                    <div
                        aria-labelledby="info-tab"
                        className="tw-block"
                        id="info"
                        role="tabpanel"
                    >
                        <table className="tw-w-full tw-mb-4 tw-text-gray-650">
                            <tbody>
                                {item.invAdmin &&
                                    item.invAdmin.map((entry, index) => (
                                        <tr key={index}>
                                            <td className={`${tableDataStylesAlignMiddle} tw-w-1/4`}>
                                                <b>{entry.label}</b>
                                            </td>
                                            <td className={tableDataStylesAlignMiddle}>
                                                {entry.data?.replace(NBSPReplace, '')}
                                                {entry.phone && (
                                                    <a
                                                        className="tw-mr-2"
                                                        href={entry.phone.url}
                                                    >
                                                        {entry.phone.label}
                                                    </a>
                                                )}
                                                {entry.email && (
                                                    <a
                                                        className="tw-mr-2"
                                                        href={`mailto:${entry.email.to}?Subject=${encodeURI(entry.email.subject)}`}
                                                    >
                                                        Email
                                                    </a>
                                                )}
                                                {entry.url && entry.label === 'Grainger Item' && (
                                                    <>
                                                        {' - '}
                                                        <a
                                                            target="_blank"
                                                            href={entry.url}
                                                            id="graingerLink"
                                                        >
                                                            Link to Grainger
                                                        </a>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                <tr>
                                    <td className={tableDataStylesAlignMiddle}>
                                        <b>Product Category: </b>
                                    </td>
                                    <td className={tableDataStylesAlignMiddle}>
                                        <a
                                            href={`/cat${item.cat}.shtml`}
                                            id="productCategory"
                                        >
                                            {item.cat} {item.catdesc}
                                        </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={tableDataStylesAlignMiddle}>
                                        <b>Product Group: </b>
                                    </td>
                                    <td className={tableDataStylesAlignMiddle}>
                                        <a
                                            href={`/grp${item.invngroup}.shtml`}
                                            id="productGroup"
                                        >
                                            {item.invngroup} {item.invngroupdesc}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )}
                {openTab === 'xRef' && item.publicXref?.length > 0 && (
                    <div
                        aria-labelledby="xrefs-tab"
                        id="xrefs"
                        role="tabpanel"
                    >
                        <table className="tw-w-full tw-mb-4 tw-text-gray-650">
                            <thead>
                                <tr>
                                    <th className={`${tableHeaderStylesNoBorder} tw-border-t`}>&nbsp;</th>
                                    <th className={`${tableHeaderStylesNoBorder} tw-border-t`}>Name</th>
                                    <th className={`${tableHeaderStylesNoBorder} tw-border-t`}>Item</th>
                                    <th className={`${tableHeaderStylesNoBorder} tw-border-t`}>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {item.customXrefItem && (
                                    <tr>
                                        <td className={tableDataStylesAlignTop}>
                                            {item.customXrefItem.image === '' ? (
                                                <img
                                                    alt="Your number"
                                                    src="/dimg/l-yournbr.gif"
                                                />
                                            ) : (
                                                <img
                                                    alt={item.customXrefItem.company}
                                                    src={`/dimg/${item.customXrefItem.image}`}
                                                />
                                            )}
                                        </td>
                                        <td className={tableDataStylesAlignTop}>
                                            <b>{item.customXrefItem.company}</b>
                                        </td>
                                        <td className={tableDataStylesAlignTop}>
                                            <b>{item.customXrefItem.xrefItem}</b>
                                        </td>
                                        <td className={tableDataStylesAlignTop}>
                                            <b>{item.customXrefItem.description}</b>
                                        </td>
                                    </tr>
                                )}
                                {item.publicXref?.map((xref, index) => (
                                    <tr key={index}>
                                        <td className={tableDataStylesAlignTop}>
                                            {xref.image === '' ? (
                                                <img
                                                    alt="Your number"
                                                    src="/dimg/l-yournbr.gif"
                                                />
                                            ) : (
                                                <img
                                                    alt={xref.company}
                                                    src={`/dimg/${xref.image}`}
                                                />
                                            )}
                                        </td>
                                        <td className={tableDataStylesAlignTop}>{xref.company}</td>
                                        <td className={tableDataStylesAlignTop}>{xref.xrefItem}</td>
                                        <td className={tableDataStylesAlignTop}>{xref.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
                {openTab === 'legal' && (
                    <div
                        aria-labelledby="legal-tab"
                        id="legal"
                        role="tabpanel"
                    >
                        {user.canViewPrice() && (
                            <p className="tw-text-red-500">
                                Imperial's product pricing is subject to change per your agreement with Imperial. Tax and freight
                                calculations are estimates and are subject to change without notice. Product pricing is a strictly private
                                matter between you and Imperial Supplies LLC Unauthorized release, republication, or distribution of this
                                pricing is strictly prohibited.
                            </p>
                        )}
                        {(user.isAccountLevel() || user.canOrder()) && (
                            <p className="tw-text-red-500">
                                On hand quantities are not committed to orders until release. Therefore all on hand values displayed here
                                are accurate AT THE MOMENT this page is accessed.
                                {user.canOrder() &&
                                    ` A product can be cancelled even if this screen shows it as available since it can be
                                committed to another order before the release of your order.`}
                            </p>
                        )}
                        <p className="tw-text-red-500">
                            All information contained herein is the property of Imperial Supplies LLC, and is published here for your use
                            only. Any reproduction or distribution of this information without prior written consent from Imperial Supplies
                            LLC is strictly prohibited.
                        </p>
                        <p className="tw-text-red-500">
                            Imperial Supplies LLC does not provide services and products outside the United States
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};
